import styles from './PageGrid.module.css';

interface IPageGridProps {
  children: React.ReactNode;
  splitEarly?: boolean
}

const PageGrid = ({ children, splitEarly }: IPageGridProps) => {
  return (
    <div
      className={`${styles.gridLayout} ${splitEarly ? styles.gridLayoutSplitEarly : undefined}`}
    >
      {children}
    </div>
  );
};

export default PageGrid;
